/* Slideshow */
document.addEventListener('DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('.slideshow-section');
  sliders.forEach(function(section) {
    var track = section.querySelector('.slideshow-track');
    var slides = section.querySelectorAll('.slideshow-slide');
    var dots = section.querySelectorAll('.slideshow-dot');
    var current = 0;
    var total = slides.length;
    if (!track || total === 0) return;

    function goTo(n) {
      current = ((n % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    var prev = section.querySelector('.slideshow-prev');
    var next = section.querySelector('.slideshow-next');
    if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
    if (next) next.addEventListener('click', function() { goTo(current + 1); });
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); });
    });
    setInterval(function() { goTo(current + 1); }, 5000);
  });

  /* Espace tabs */
  document.querySelectorAll('.espace-tabs').forEach(function(tabGroup) {
    tabGroup.querySelectorAll('.espace-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabGroup.querySelectorAll('.espace-tab').forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
      });
    });
  });
});
